// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"94":"f3209d29","433":"1de7f14b"}[chunkId] + ".chunk.css";
};